module.exports = __webpack_public_path__ + "img/worksbot_img19112527.fac7f9ea.jpg";